import React,{ Component } from 'react';
import { Button, Form,Select, message } from 'antd';
import { getGroupList } from '../../model/group/requests';
import { bindGroup } from '../../model/user/requests';
import storage from '../../utils/storage';
import { configs } from '../../config/config';
import { route } from '../../routes/routes';

export const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 14,
    },
};

export const tailLayout = {
    wrapperCol: {
      offset: 8,
      span: 16,
    },
};

const Option = Select.Option;
class BindGroup extends Component {
    formRef = React.createRef();
    constructor(props){
        super(props)
        this.state= {
            groupList:[],
            group_id:"",
            data:{}
        }
    }
    componentWillUnmount(){
        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
        }
    }
    componentDidMount(){

        if (!storage.check(configs.cache.tokenKey)) {
            this.props.history.push("/")
            return false;
        }

        let data = storage.get(configs.cache.tokenKey)
        let groupList = [];
        getGroupList().then(res=>{
            if(res.data.code === 200){
                groupList = res.data.data
                this.setState({
                    groupList:groupList,
                    data:data
                })
                this.formRef.current.setFieldsValue(data);
            }else{
                message.error(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })
    }

    handlerSubmit = (e) => {

         let id = parseInt(this.props.match.params.id);
         let group_id = this.state.group_id
         
         if(group_id === 0){
            message.warn("Please Chosen a Group")
            return false;
         }

         bindGroup({id:id,group_id:group_id}).then(res=>{
            if(res.data.code === 200){
                message.success("Bind Group Ok")
                this.props.history.push(route.user.index)
            }else{
                message.warn(res.data.msg)
            }
         }).catch(err=>{
            message.error(" Bind Group Failed")
         })


         

    }

    handlerChange = (item) =>{
        this.setState({
            group_id:item
        })
    }

    render(){
        const {groupList,data} = this.state;
        return(
            <>
                <Form
                    {...layout}
                    ref={this.formRef}
                    initialValues={{
                        group_id:data.group_id
                    }}
                    >
                    <Form.Item label={"Group Name"} name={"group_id"}>
                        <Select
                         onChange={this.handlerChange}
                        >
                            <Option key={0} value={0} >Chosen A Group</Option>
                            {groupList.length > 0  &&  groupList.map((items) => {
                                return (<Option key={items.id} value={items.id}> {items.name} </Option>)
                            })}
                        </Select>
                    </Form.Item>
                        <Form.Item
                            wrapperCol={{
                                span: 12,
                                offset: 6,
                              }}
                        >
                            <Button 
                                type="primary" 
                                style={{background: "#851dd6",color:"white" }}
                                onClick = {this.handlerSubmit}
                            >
                                Submit
                            </Button>
                        </Form.Item>    

                </Form>      
            
            </>
        )
    }


}

export default BindGroup;